import { render, staticRenderFns } from "./BrandVideo.vue?vue&type=template&id=6ec0e70c&scoped=true&"
import script from "./BrandVideo.vue?vue&type=script&lang=ts&"
export * from "./BrandVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandVideo.vue?vue&type=style&index=0&id=6ec0e70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0e70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec0e70c')) {
      api.createRecord('6ec0e70c', component.options)
    } else {
      api.reload('6ec0e70c', component.options)
    }
    module.hot.accept("./BrandVideo.vue?vue&type=template&id=6ec0e70c&scoped=true&", function () {
      api.rerender('6ec0e70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/BrandVideo.vue"
export default component.exports